import React from 'react';
export function PainSection() {
  return <section className="py-20 px-4 max-w-3xl mx-auto" data-id="element-199">
      <div className="text-center mb-10" data-id="element-200">
        <span className="text-5xl mb-4 block" data-id="element-201">😤</span>
        <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-202">
          Si enseñas italiano, probablemente esto te suena…
        </h2>
      </div>

      <div className="glass-card rounded-2xl p-8 md:p-10" data-id="element-203">
        <p className="text-xl text-gray-200 mb-6 leading-relaxed" data-id="element-204">
          Sabes que eres buen profesor… pero tu ingreso depende completamente de
          tu tiempo.
        </p>

        <p className="text-xl font-bold text-brand-red mb-8" data-id="element-205">
          Si no das clases → no ganas dinero.
        </p>

        <p className="text-lg text-gray-300 mb-4" data-id="element-206">Y aunque te esfuerces más:</p>

        <ul className="space-y-4 mb-8 text-lg text-gray-200" data-id="element-207">
          <li className="flex items-center" data-id="element-208">
            <div className="w-2 h-2 bg-brand-red rounded-full mr-4" data-id="element-209"></div>
            No puedes multiplicarte
          </li>
          <li className="flex items-center" data-id="element-210">
            <div className="w-2 h-2 bg-brand-red rounded-full mr-4" data-id="element-211"></div>
            No puedes subir precios fácilmente
          </li>
          <li className="flex items-center" data-id="element-212">
            <div className="w-2 h-2 bg-brand-red rounded-full mr-4" data-id="element-213"></div>
            Siempre estás intercambiando horas por dinero
          </li>
        </ul>

        <div className="bg-brand-dark/50 p-6 rounded-xl border border-white/5" data-id="element-214">
          <p className="text-lg text-gray-300 italic mb-4" data-id="element-215">
            Mientras tanto, ves a otros profesores creciendo online, vendiendo
            cursos y teniendo libertad…
          </p>
          <p className="text-xl font-bold text-white" data-id="element-216">
            Y te preguntas:{' '}
            <span className="text-brand-gold" data-id="element-217">
              "¿Qué están haciendo diferente?"
            </span>
          </p>
        </div>
      </div>
    </section>;
}